// extracted by mini-css-extract-plugin
module.exports = {"burger":"burger__26lV9","gray":"gray__2CQCr"};